/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forgrowingbusinesses2Inputs */

const en_forgrowingbusinesses2 = /** @type {(inputs: Forgrowingbusinesses2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For growing businesses`)
};

const de_forgrowingbusinesses2 = /** @type {(inputs: Forgrowingbusinesses2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für wachsende Unternehmen`)
};

/**
* | output |
* | --- |
* | "For growing businesses" |
*
* @param {Forgrowingbusinesses2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const forgrowingbusinesses2 = /** @type {((inputs?: Forgrowingbusinesses2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forgrowingbusinesses2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forgrowingbusinesses2(inputs)
	return de_forgrowingbusinesses2(inputs)
});
export { forgrowingbusinesses2 as "forGrowingBusinesses" }